import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  IconButton,
  TextField,
  Button,
  Container,
  Divider, Snackbar,
  Alert,
  CircularProgress
} from "@mui/material";

import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import { fetchIP } from "../utils/fetchIP";

import { useNavigate } from "react-router-dom";
import API from "../../api/api";

export default function HelpSupport() {

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleSubmitTicket = async () => {

    if (!message.trim()) {
      setSnackbar({
        open: true,
        message: "Please describe your issue",
        severity: "warning"
      });

      return;
    }

    try {

      setLoading(true);

      await API.post("/support-ticket", {
        user_id: user.id || user.user_id,
        message,
        frontend_ip: null // Backend securely handles this now
      });

      setSnackbar({
        open: true,
        message: "Support ticket submitted successfully",
        severity: "success"
      });
      setMessage("");

    } catch (err) {

      console.error(err);

      setSnackbar({
        open: true,
        message: "Failed to submit support ticket",
        severity: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f5f5f5" }}>

      {/* HEADER */}
      <Box
        sx={{
          background: "#F8D548",
          borderRadius: "0 0 30px 30px",
          pb: 3,
          pt: 2
        }}
      >
        <Container maxWidth="sm">

          <Stack direction="row" alignItems="center" spacing={1}>

            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                color: "#4a332e",
                bgcolor: "rgba(255,255,255,0.15)"
              }}
            >
              <ArrowBackIosNewIcon fontSize="small" />
            </IconButton>

            <Typography
              variant="h6"
              fontWeight="800"
              color="#4a332e"
            >
              Help & Support
            </Typography>

          </Stack>
        </Container>
      </Box>

      <Container
        maxWidth="sm"
        sx={{ mt: 2, pb: 10 }}
      >

        {/* CONTACT INFO */}

        <Paper
          sx={{
            borderRadius: "18px",
            overflow: "hidden"
          }}
        >

          <Stack spacing={0}>

            {/* EMAIL */}
            <Box sx={{ p: 2.2 }}>
              <Stack direction="row" spacing={2} alignItems="center">

                <EmailIcon sx={{ color: "#4a332e" }} />

                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    Support Email
                  </Typography>

                  <Typography
                    component="a"
                    href="mailto:support@mealno.com"
                    sx={{
                      fontWeight: "700",
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                  >
                    support@mealno.com
                  </Typography>
                </Box>

              </Stack>
            </Box>

            <Divider />

            {/* MOBILE */}
            <Box sx={{ p: 2.2 }}>
              <Stack direction="row" spacing={2} alignItems="center">

                <PhoneIcon sx={{ color: "#4a332e" }} />

                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    Mobile Number
                  </Typography>

                  <Typography
                    component="a"
                    href="tel:+918116952030"
                    sx={{
                      fontWeight: "700",
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                  >
                    +91 70030 57695
                  </Typography>
                </Box>

              </Stack>
            </Box>

            <Divider />

            {/* WHATSAPP */}
            <Box sx={{ p: 2.2 }}>
              <Stack direction="row" spacing={2} alignItems="center">

                <WhatsAppIcon sx={{ color: "#25D366" }} />

                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                  >
                    WhatsApp Support
                  </Typography>

                  <Typography
                    component="a"
                    href="https://wa.me/917003057695"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      fontWeight: "700",
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                    }}
                  >
                    +91 70030 57695
                  </Typography>
                </Box>

              </Stack>
            </Box>

          </Stack>

        </Paper>

        {/* SUPPORT TICKET */}

        <Paper
          sx={{
            mt: 2,
            borderRadius: "18px",
            p: 3
          }}
        >

          <Typography
            variant="subtitle1"
            fontWeight="900"
            mb={1}
          >
            Please write down  your issue
          </Typography>

          <TextField
            fullWidth
            multiline
            rows={6}
            placeholder="Describe your issue here..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "14px"
              }
            }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmitTicket}
            disabled={loading}
            sx={{
              mt: 2,
              py: 1.6,
              borderRadius: "14px",
              fontWeight: "900",
              textTransform: "none",
              fontSize: "1rem",
              background:
                "#4a332e"
            }}
          >
            {loading ? (
              <CircularProgress
                size={22}
                sx={{ color: "#fff" }}
              />
            ) : (
              "Submit Ticket"
            )}
          </Button>

        </Paper>

      </Container>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() =>
          setSnackbar({
            ...snackbar,
            open: false
          })
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          elevation={6}
          onClose={() =>
            setSnackbar({
              ...snackbar,
              open: false
            })
          }
          sx={{
            width: "100%",
            borderRadius: "14px",
            fontWeight: "700"
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

    </Box>
  );
}